import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { init } from "@emailjs/browser";

// Initialize EmailJS with your public key
init("qfVnFtZHSAmh2zLrX");

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
